module.exports = __webpack_public_path__ + "b4643ebbfb5be1d58fba64a018fae2e2.jpg";